
export const getStripeToken = (card) =>
    new Promise((resolve, reject) => {
        window.Stripe.setPublishableKey("pk_J3AuWyw29oLWCSzF4QQ7hPt5nvO6o");
        window.Stripe.card.createToken(card, (status, { error, id }) => {
            if (error) {
                reject(error.message);
            } else {
            resolve(id);
            }
        });
    });


// WEBPACK FOOTER //
// ./src/stripe/index.js